<template>

    <main id="main" class="ms-sm-auto">
        <div class="container">

            <div class="faq-title">{{$t('lisa_web_help_you')}}</div>

            <div class="faq-search-form">
                <div class="header-search-form">
                    <form method="get" action="/faq">
                        <input id="input-search" type="text" name="q" @keyup="handleSearch" :placeholder="$t('search')">

                        <i class="lisa-icon-header-search"></i>
                        <i class="lisa-icon-search-close" @click="clearSearch"></i>
                    </form>
                </div>
            </div>

            <div class="faq-card">
                <div class="faq-card-title">{{$t('lisa_web_all_topic')}}</div>
                <div class="faq-card-body">
                    <div class="faq-topics">
                        <div class="row">
                            <div class="col-md-3" v-for="(t, index) in topics">
                                <div :class="topic.id == t.id?'faq-topic active':'faq-topic'" @click="selectTopic(t)">
                                    <div class="faq-topic-img">
                                        <img :src="getImageTopic(t)" alt="" />
                                    </div>
                                    <div class="faq-topic-title">{{$t(`${t.name}`)}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="faq-card">
                <div class="faq-card-title"><i class="lisa-icon-faq-topic"></i>{{$t('lisa_web_frequently_question')}}</div>
                <div class="faq-card-body">
                    <div class="faq-aqs">
                        <div class="row" v-if="topic">
                            <div class="col-md-12" v-for="(question, index) in topic.questions">
                                <div class="faq-aq" v-if="(question.name.toLowerCase().search(search.toLowerCase()) != -1  || search == '') && language==question.Language">
                                    <input type="checkbox" :id="'faq-aq-item-'+question.id" class="faq-aq-input" v-model="question.is_checked" />

                                    <label :for="'faq-aq-item-'+question.id" class="faq-aq-title">
                                        <i class="lisa-icon-faq-question"></i> {{question.name}}
                                    </label>

                                    <div class="faq-aq-body">
                                        <div v-html="question.content">
                                        </div>

                                        <!-- <div class="faq-aq-body-footer">
                                            <a href="javascript:void(0)" @click  = "selectQuestion(question)">
                                                More questions of {{topic.name}} topics <i class="lisa-icon-arrow-right"></i>
                                            </a>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>

</template>

<script>
import axios from "axios";
import { pushQueries } from '../../utils/utils'
import { mapGetters } from 'vuex'
import {getFaqs} from '../../models/faq';

import { claimDailyBonus } from "../../models/reward";

export default {
    name: "FAQIndex",
    title: 'FAQs',

    data() {
        const language = localStorage.getItem('lang') ? localStorage.getItem('lang') : "vi"
        return {
            topic: {},
            topics: [],
            isLoading: true,
            search: "",
            language: language,
        };
    },

    created() {
        //this.$store.commit('setMenuActive', 'inbox');

        this.fetch();
    },

    methods: {
        async fetch(page = 1) {
            const that = this;

            this.page = page;

            const params = {
                page: this.page,
            };

            pushQueries(this.$router, '/faq', params);

            await axios.all([
                getFaqs(params),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                //that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                that.topics = response.data.results ? response.data.results.topics : [];
                that.topic = that.topics[0]?that.topics[0]:null
            }));
        },
        handleSearch(e){
            this.search = e.target.value;
            console.log(this.search);
        },
        clearSearch(){
            $("#input-search").val('');
            this.search = ''
        },
        selectTopic(topic){
            this.topic = topic;
        },
        selectQuestion(question){
            const that = this;
            //this.questionSelected = question;

            /*that.topic.questions.forEach((q, index)=>{
                if(q.is_checked && that.topic.questions[index+1]){
                    q.is_checked = false;
                    
                    that.topic.questions[index+1].is_checked = true;
                }
            })*/
        },

        getImageTopic(topic){
            switch(topic.type){
                case 'account':
                    return '/themes/web/assets/images/faq-1.svg';
                case 'report':
                    return '/themes/web/assets/images/faq-2.svg';      
                default:
                    return '/themes/web/assets/images/faq-3.svg';                    
            }
        }
    }
}
</script>

<style scoped>
    .lisa-icon-search-close{
        cursor: pointer;
    }
</style>
